import {Component, OnInit} from '@angular/core';
import {VerbrauchsanalyseAusstiegComponent} from "../../verbrauchsanalyse/verbrauchsanalyse.ausstieg.component";
import {StepService} from "../../services/step.service";
import {Router} from "@angular/router";
import {ElementService} from "../../services/element.service";
import {PortalService} from "../../services/portal.service";
import {HeizcheckAnfrage} from "../anfrage/heizcheck.anfrage";
import {HeizcheckRequestService} from "../services/heizcheck-request.service";

/**
 * Special component for the step to stop the advisor because we can not offer anything to the user
 */
@Component({
    selector: 'app-verbrauchsanalyse-heizcheck-ausstieg',
    templateUrl: './../../verbrauchsanalyse/verbrauchsanalyse.ausstieg.component.html',
    standalone: false
})
export class VerbrauchsanalyseHeizcheckAusstiegComponent extends VerbrauchsanalyseAusstiegComponent implements OnInit {

  /**
   * the users input
   */
  anfrage: HeizcheckAnfrage;

  /**
   *
   * @param stepService
   * @param router
   * @param elementService
   * @param portalService
   * @param requestService
   */
  constructor(protected stepService: StepService, protected router: Router, protected elementService: ElementService, protected portalService: PortalService, protected requestService: HeizcheckRequestService) {
    super(stepService, router, elementService, portalService);
  }

  /**
   * @inheritDoc
   */
  ngOnInit() {
    this.anfrage = this.requestService.getAnfrage();
    this.textkeyPrefix = 'heizcheck';

    super.ngOnInit();
  }
}
